import React from 'react'
import { useTranslation } from "react-i18next";

const Tr = (props) => {
    const { t } = useTranslation();

    const single = props.single;
    const openModal = props.openModal;
    const openImageModal = props.openImageModal;
    const cardNumber = props.cardNumber;
    const confirmPackage = props.confirmPackage;
    const cardList = props.cardList;
    const setCardList = props.setCardList;
    const setCurrentCard = props.setCurrentCard;

    const editCard = (e) => {
        e.preventDefault();

        let single = cardList.find(card => card.id === parseInt(e.target.value));
        setCurrentCard({
            ...single,
            update: true,
        });
        
        openModal();
    }

    const deleteCard = (e) => {
        e.preventDefault();
        
        let oripa = cardList.find(card => card.id === parseInt(e.target.value));
        
        if (window.confirm(`${oripa.name}`+ t('tr.confirm'))) {
            let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
            if (xsrfToken) {
                xsrfToken = xsrfToken.split('=')[1]
            }
            let token = document.cookie.split('; ').find(row => row.startsWith('token'));
            if (token) {
                token = token.split('=')[1]
            }

            fetch(`${process.env.REACT_APP_API_URL}/api/single-package-card/delete/${oripa.id}`, {
                method: 'POST',
                headers: {
                'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
                'Authorization': `Bearer ${token}`,
                },
                credentials: 'include',
            })
            .then(response => {
                if (!response.ok) {
                    // data.messageにエラーメッセージが入っている
                    return response.json().then(data => {
                        throw new Error(data.message);
                    });
                }
                return response.json();
            })
            .then(data => {
                if(!data.errors) {
                    let newCardList = cardList.filter(card => card.id !== single.id);
                    setCardList(newCardList);
                }
            })
            .catch((error) => {
                alert(error.message);
                console.error('Error:', error);
            });
        }
    }


    return (
        <>
            <tr>
                <td><img src={single.url} alt="" onClick={openImageModal}/></td>
                <td>{single.name}</td>
                <td>{t("package_master." + single.singleTypeName)}</td>
                <td>{single.stock}</td>
                <td>{single.rewardPoint}</td>
                <td>{single.isPsaEnabled == "1" ? <>PSA {single.psa}</> : <>-</>}</td>
                <td><div>{single.tagName && t("single_card_tags." + single.tagName)}</div></td>
                <td>
                    <button value={single.id} onClick={editCard}>{t('tr.edit')}</button><br/>
                    {!confirmPackage && <button value={single.id} onClick={deleteCard}>{t('tr.delete')}</button>}
                </td>
            </tr>
        </>
    )
}

export default Tr